import {
	Entity,
	EntityEntityAttribute, EntityListEntityAttribute,
	IntegerEntityAttribute,
	StringEntityAttribute
} from '../base/Entity';

import {Series} from './Series';
import {slugify} from '../util/slugify';
import {Video} from './Video';

/**
 * @name Category
 * @property {Number} Id
 * @property {String} Name
 * @property {Series} Series
 */
export class Category extends Entity {
	getSmallThumbnail() {
		return `https://www.rwbybrasil.com/dynamic/videos/${this.Id}th.jpg?`;
	}

	getRoute() {
		return {
			name: 'category',
			params: {
				seriesId: this.Series.Id,
				seriesName: slugify(this.Series.Name.toLowerCase()),
				categoryId: this.Id,
				categoryName: slugify(this.Name.toLowerCase())
			}
		}
	}
}

Category.Register('Category');
Category.Attributes = [
	new IntegerEntityAttribute('Id'),
	new StringEntityAttribute('Name'),
	new EntityEntityAttribute('Series', Series),
	new EntityListEntityAttribute('Videos', Video)
];

export default Category;
